module.exports = __webpack_public_path__ + "static/media/Facebook.33e3bdae.svg";